module.exports = __webpack_public_path__ + "static/media/gbqq.1cb9e662.mp3";